<template>
   <!-- 分页器 -->
   <div class="page-box" v-if="total">
      <el-pagination id="pageBtn" background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pageSize" :current-page="currentPage" :total="total" @current-change="pageChange" @size-change="handleSizeChange"/>
   </div>
</template>

<script>
export default {
  name: 'PageButton',
  props: {
    // 当前页码
    currentPage: {
      type: Number,
      default: 1
    },
    // 总条数
    total: {
      type: Number,
      default: 0
    },
    // 每页显示条数
    pageSize: {
      type: Number,
      default: 10
    }
  },
  methods: {
    // 页码改变时触发
    pageChange (val) {
      this.$emit('pageChange', val)
    },
    // 页码大小改变时触发
    handleSizeChange (val) {
      this.$emit('sizeChange', val)
    }
  }
}
</script>

<style>
.page-box {
  display: flex;
  justify-content: flex-end; /* 水平方向靠右 */
  align-items: flex-end; /* 垂直方向靠下 */
  margin-top: 10px;
}
</style>
